import productData from '@/data/products.json'; // Adjust path as needed

const specificRegions = ['us', 'ie', 'za', 'au', 'ca'];

export default (_, inject) => {
  inject('regionUrl', function (productId, region = 'uk') {
    // Normalise: strip any 'en_' prefix so 'en_us' becomes 'us', 'en_gb' becomes 'gb', etc.
    const r = (region?.toLowerCase() || 'uk')
        .replace(/^en-/, '')   // 'en-us' → 'us', 'en-gb' → 'gb'
        .replace(/^en_/, '')   // 'en_us' → 'us', 'en_gb' → 'gb'

    // 'en' and 'uk' both mean the default region
    const normalised = (r === 'en' || r === 'uk') ? 'en' : r
    const key = specificRegions.includes(normalised) ? 'en_' + normalised : 'en'

    console.log(`🌍 Resolving region URL for productId: ${productId}, region: ${r}, key: ${key}`);

    const product = productData.find(p => p.id === Number(productId));

    if (!product) {
      // console.warn(`⚠️ Product not found for ID: ${productId}`);
      return '/';
    }

    if (!product.page) {
      // console.warn(`⚠️ Product has no 'page' property:`, product);
      return '/';
    }

    const page = product.page[key] || product.page.en;

    if (!page) {
      // console.warn(`⚠️ No URL found for region key: '${key}' — falling back to root`);
      return '/';
    }

    console.log(`✅ Resolved URI for product ${productId} in region '${r}': ${page.uri}`);
    return page.uri || '/';
  });
};
